import React, { Component, ErrorInfo, ReactNode } from "react";
import { Button } from "reactstrap";

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false,
    };

    public static getDerivedStateFromError(_: Error): State {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("Uncaught error:", error, errorInfo);
    }

    public render() {
        if (this.state.hasError) {
            return (
                <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 dark:bg-zinc-900">
                    <div className="text-center p-8 bg-white dark:bg-zinc-800 rounded-lg shadow-md max-w-md w-full mx-4">
                        <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-4">Something went wrong</h1>
                        <p className="text-gray-600 dark:text-gray-400 mb-6">
                            An unexpected error has occurred. Please try reloading the page.
                        </p>
                        <Button
                            color="primary"
                            onClick={() => window.location.reload()}
                            className="w-full"
                        >
                            Reload Page
                        </Button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
